import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, CardMedia, IconButton, Modal } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { useSwipeable } from 'react-swipeable';
const ImageSelector = ({ images }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleNext = () => {
        setSelectedIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
    const handleBack = () => {
        setSelectedIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };
    const handlers = useSwipeable({
        onSwipedLeft: handleNext,
        onSwipedRight: handleBack,
        trackMouse: true,
    });
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: [_jsxs(Box, Object.assign({}, handlers, { position: "relative", width: "60%", maxWidth: "500px", maxHeight: "25vh", sx: {
                    marginBottom: 2,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    borderRadius: 2,
                }, onClick: openModal, children: [_jsx(Box, { sx: {
                            display: 'flex',
                            transition: 'transform 0.5s ease-in-out',
                            transform: `translateX(-${selectedIndex * 100}%)`,
                        }, children: images.map((image, index) => (_jsx(CardMedia, { component: "img", image: image, alt: `Image ${index + 1}`, sx: {
                                width: '100%',
                                flexShrink: 0,
                                objectFit: 'cover',
                                height: '280px',
                                maxHeight: '15vh'
                            } }, index))) }), images.length > 1 && (_jsxs(_Fragment, { children: [_jsx(IconButton, { sx: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: '16px',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                                }, onClick: (e) => {
                                    e.stopPropagation();
                                    handleBack();
                                }, children: _jsx(KeyboardArrowLeft, {}) }), _jsx(IconButton, { sx: {
                                    position: 'absolute',
                                    top: '50%',
                                    right: '16px',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                                }, onClick: (e) => {
                                    e.stopPropagation();
                                    handleNext();
                                }, children: _jsx(KeyboardArrowRight, {}) })] }))] })), _jsx(Box, { display: "flex", gap: 1, children: images.map((image, index) => (_jsx(Box, { onClick: () => setSelectedIndex(index), sx: {
                        cursor: 'pointer',
                        border: selectedIndex === index ? '3px solid var(--actionColor)' : '3px solid transparent',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        width: '60px',
                        height: '60px',
                        '& img': {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        },
                    }, children: _jsx("img", { src: image, alt: `Thumbnail ${index + 1}` }) }, index))) }), _jsx(Modal, { open: isModalOpen, onClose: closeModal, children: _jsxs(Box, { sx: {
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        maxWidth: '90vw',
                    }, children: [images.length > 1 && (_jsxs(_Fragment, { children: [_jsx(IconButton, { sx: {
                                        position: 'absolute',
                                        top: '50%',
                                        left: '16px',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        color: 'white',
                                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                                    }, onClick: (e) => {
                                        e.stopPropagation();
                                        handleBack();
                                    }, children: _jsx(KeyboardArrowLeft, {}) }), _jsx(IconButton, { sx: {
                                        position: 'absolute',
                                        top: '50%',
                                        right: '16px',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        color: 'white',
                                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                                    }, onClick: (e) => {
                                        e.stopPropagation();
                                        handleNext();
                                    }, children: _jsx(KeyboardArrowRight, {}) })] })), _jsx(CardMedia, { component: "img", image: images[selectedIndex], alt: `Image ${selectedIndex + 1}`, sx: {
                                maxHeight: '80vh',
                                maxWidth: '100%',
                                objectFit: 'contain',
                            }, onClick: closeModal })] }) })] }));
};
export default ImageSelector;
